export default {
  common: {
    back: 'Zurück',
    contact: 'Kontakt',
    email: 'support@wedora.fr',
    privacyEmail: 'privacy@wedora.fr',
  },
  termsOfService: {
    title: 'Nutzungsbedingungen',
    sections: {
      introduction: {
        title: '1. Einführung',
        content: 'Willkommen bei Wedora. Mit der Nutzung unseres Dienstes stimmen Sie diesen Nutzungsbedingungen zu. Bitte lesen Sie diese sorgfältig, bevor Sie unsere Plattform nutzen.',
      },
      description: {
        title: '2. Dienstbeschreibung',
        content: 'Wedora ist eine Hochzeitsplanungsplattform, die es Paaren ermöglicht:',
        features: [
          'Ihre Gästeliste zu verwalten',
          'Ihr Budget zu verfolgen',
          'Ihre Aufgaben zu organisieren',
          'Ihre Hochzeitswebsite zu erstellen',
          'Mit ihren Dienstleistern zu kommunizieren',
        ],
      },
      accounts: {
        title: '3. Benutzerkonten',
        content: 'Um Wedora zu nutzen, müssen Sie ein Konto erstellen. Sie sind verantwortlich für die Wahrung der Vertraulichkeit Ihrer Anmeldedaten und aller Aktivitäten, die unter Ihrem Konto stattfinden.',
      },
      usage: {
        title: '4. Nutzung des Dienstes',
        content: 'Mit der Nutzung unseres Dienstes stimmen Sie zu:',
        rules: [
          'Den Dienst nicht für illegale Zwecke zu verwenden',
          'Nicht zu versuchen, die Sicherheit des Dienstes zu kompromittieren',
          'Keine unangemessenen oder beleidigenden Inhalte zu teilen',
          'Die Rechte anderer Nutzer zu respektieren',
        ],
      },
      intellectual: {
        title: '5. Geistiges Eigentum',
        content: 'Alle Inhalte auf Wedora, einschließlich, aber nicht beschränkt auf Texte, Grafiken, Logos und Quellcode, sind Eigentum von Wedora oder seinen Partnern und sind durch Gesetze zum geistigen Eigentum geschützt.',
      },
      modifications: {
        title: '6. Änderungen der Bedingungen',
        content: 'Wir behalten uns das Recht vor, diese Bedingungen jederzeit zu ändern. Änderungen treten mit ihrer Veröffentlichung auf der Website in Kraft. Ihre fortgesetzte Nutzung des Dienstes nach diesen Änderungen stellt Ihre Zustimmung zu den neuen Bedingungen dar.',
      },
      contact: {
        title: '7. Kontakt',
        content: 'Für Fragen zu diesen Nutzungsbedingungen kontaktieren Sie uns bitte unter: support@wedora.fr',
      },
    },
  },
  privacyPolicy: {
    title: 'Datenschutzerklärung',
    sections: {
      introduction: {
        title: '1. Einführung',
        content: 'Bei Wedora legen wir großen Wert auf den Schutz Ihrer persönlichen Daten. Diese Datenschutzerklärung erklärt, wie wir Ihre Informationen sammeln, verwenden und schützen.',
      },
      dataCollection: {
        title: '2. Datensammlung',
        content: 'Wir sammeln folgende Informationen:',
        types: [
          'Profilinformationen (Name, Vorname, E-Mail)',
          'Informationen über Ihre Hochzeit (Datum, Ort)',
          'Gästeliste',
          'Budgetinformationen',
          'Anpassungspräferenzen',
        ],
      },
      dataUsage: {
        title: '3. Datennutzung',
        content: 'Wir verwenden Ihre Daten, um:',
        purposes: [
          'Unsere Dienste bereitzustellen und zu verbessern',
          'Ihre Erfahrung zu personalisieren',
          'Mit Ihnen bezüglich Ihres Kontos zu kommunizieren',
          'Wichtige Benachrichtigungen zu senden',
          'Unsere Dienste zu analysieren und zu verbessern',
        ],
      },
      dataProtection: {
        title: '4. Datenschutz',
        content: 'Wir implementieren angemessene Sicherheitsmaßnahmen, um Ihre Daten vor unbefugtem Zugriff, Änderung, Offenlegung oder Zerstörung zu schützen. Ihre Daten werden auf sicheren Servern gespeichert und während der Übertragung verschlüsselt.',
      },
      dataSharing: {
        title: '5. Datenweitergabe',
        content: 'Wir verkaufen niemals Ihre persönlichen Daten an Dritte. Wir können bestimmte Informationen mit unseren Dienstleistern teilen, die uns beim Betrieb unserer Plattform helfen, unter strengen Vertraulichkeitsverpflichtungen.',
      },
      rights: {
        title: '6. Ihre Rechte',
        content: 'In Übereinstimmung mit der DSGVO haben Sie folgende Rechte:',
        list: [
          'Recht auf Zugang zu Ihren Daten',
          'Recht auf Berichtigung',
          'Recht auf Löschung',
          'Recht auf Datenübertragbarkeit',
          'Recht auf Widerspruch gegen die Verarbeitung',
        ],
      },
      cookies: {
        title: '7. Cookies',
        content: 'Wir verwenden Cookies, um Ihre Erfahrung auf unserer Plattform zu verbessern. Sie können die Verwendung von Cookies über Ihre Browser-Einstellungen steuern.',
      },
      contact: {
        title: '8. Kontakt',
        content: 'Für Fragen zu unserer Datenschutzerklärung oder zur Ausübung Ihrer Rechte kontaktieren Sie uns bitte unter: privacy@wedora.fr',
      },
    },
  },
}; 